import { IrisTranslatedFieldSet } from '@iris/common/models';
import { IrisDMSTagI } from './IrisDMSTag';
import { omit } from 'lodash';

export enum IrisDmsFolderActionType {
  Download = 'Download',
  Edit = 'Edit',
  ShowInfo = 'ShowInfo',
  Add = 'Add',
  Copy = 'Copy',
  Move = 'Move',
  Lock = 'Lock',
  Import = 'Import',
  Remove = 'Remove',
}

export interface IrisDmsFolderResourceI {
  id: number;
  path: string;
}

export interface IrisDMSFolderI {
  name: string;
  nameTranslated: string;
  id: string;
  path: string;
  parentId: string;
  parentPath: string;
  createdOn: string;
  createdBy: number;
  updatedOn: string;
  updatedBy: number;
  comment: string;
  isLocked: boolean;
  isParentLocked: boolean;
  isSystem: boolean;
  isTrashBin: boolean;
  children: IrisDMSFolderI[];
  projectId: number;
  originalId: string;
  originalName: string;
  originalPath: string;
  removedDate: number;
  tags: IrisDMSTagI[];
  customIconClass: string;
  color: string;
  isNeedChildren?: boolean;
  hasChildren: boolean;
  fileCount: number;
  expanded?: boolean;
  syncConfigId?: number;
  isProjectFolder?: boolean;
  isRecentFilesFolder?: boolean;
  translations?: IrisTranslatedFieldSet;
  deletedOn?: string;
  readonly hasFiles: boolean;
  readonly isExpanded: boolean;
  readonly normilizedColor: string;
}

export class IrisDMSFolder implements IrisDMSFolderI {
  name: string = undefined;
  nameTranslated: string = undefined;
  id: string = undefined;
  path: string = undefined;
  parentId: string = undefined;
  parentPath: string = undefined;
  createdOn: string = undefined;
  createdBy: number = undefined;
  updatedOn: string = undefined;
  updatedBy: number = undefined;
  comment: string = undefined;
  isLocked: boolean = undefined;
  isParentLocked: boolean = undefined;
  isSystem: boolean = undefined;
  isTrashBin: boolean = undefined;
  children: IrisDMSFolderI[] = [];
  projectId: number = undefined;
  originalId: string = undefined;
  originalName: string = undefined;
  originalPath: string = undefined;
  removedDate: number = undefined;
  tags: IrisDMSTagI[] = [];
  customIconClass: string = undefined;
  color: string = undefined;
  isNeedChildren?: boolean = undefined;
  hasChildren = false;
  fileCount: number = undefined;
  expanded?: boolean = undefined;
  syncConfigId?: number = undefined;
  isProjectFolder?: boolean = undefined;
  isRecentFilesFolder?: boolean = undefined;
  translations?: IrisTranslatedFieldSet = undefined;
  deletedOn?: string = undefined;

  constructor(params?: Partial<IrisDMSFolderI>) {
    if (params) {
      Object.assign(this, omit(params, ['hasFiles', 'isExpanded', 'normilizedColor']));
    }
  }

  get hasFiles(): boolean {
    return this.fileCount > 0;
  }

  get isExpanded(): boolean {
    return this.expanded && this.hasChildren;
  }

  get normilizedColor(): string {
    if (!this.color) {
      return this.color;
    }
    if (this.color.startsWith('#')) {
      return this.color;
    }
    return `#${this.color}`;
  }
}

export const IrisDmsRootFolder = new IrisDMSFolder({
  id: 'root',
  name: 'label.dms.RootFolder',
  expanded: true,
});

export const IrisDmsRootFolderId = '/';

export const IrisDmsRecentFilesFolder = new IrisDMSFolder({
  id: 'recent',
  name: 'label.RecentlyUsed',
  isRecentFilesFolder: true,
  parentId: IrisDmsRootFolderId,
});
